module.exports = __webpack_public_path__ + "ac94088c2e42f526f38e4bbdc5e74e19.svg";